import {Nilable} from "@shared/utils";
import {DTO, IDTO} from "./dto";

export interface IPiramideNseDTO extends IDTO {
    id: number;
    country: string;
    nse_level: string;
    percentage: number;
}

export class PiramideNseDTO implements DTO {
    public id = 0;
    public pais = "";
    public nivelNse = "";
    public porcentaje = 0;

    constructor(json?: Nilable<Partial<IPiramideNseDTO>>) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPiramideNseDTO>): void {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.country != null) {
            this.pais = json.country;
        }
        if (json.nse_level != null) {
            this.nivelNse = json.nse_level;
        }
        if (json.percentage != null) {
            this.porcentaje = json.percentage;
        }
    }

    public toJSON(): IPiramideNseDTO {
        return {
            id: this.id,
            country: this.pais,
            nse_level: this.nivelNse,
            percentage: this.porcentaje
        };
    }
}
